export default "__VITE_ASSET__Dx4_LJgV__"